import React from 'react'

function ContractorChat() {
  return (
    <div>ContractorChat</div>
  )
}

export default ContractorChat